<template>
  <Modal
    name="ADD_DEFAULT_CONTRACT_MODAL"
    title="Aplicar Contrato Padrão"
    actions
  >
    <template v-slot:body>
      {{ customers.length + ' cliente(s) selecionado(s)' }}

      <v-select
        item-text="name"
        item-value="value"
        :items="subscriptionTypes"
        label="Tipos de Contratos"
        class="mt-4"
        v-model="subscriptionType"
        outlined
        hide-details="auto"
      />

      <HCheckbox
        v-model="getServicesFromOldContract"
        :label="$t('defaultContract.useOldContractServices')"
        class="mb-5"
      />

      <RealEstateServiceTypeSelect
        v-model="services"
        :disable="getServicesFromOldContract"
        class="mb-3"
      />

      <v-row>
        <v-col cols="5">
          <SelectDate
            v-model="startDate"
            :label="$t('contract.label.startDate')"
          />
        </v-col>
        <v-col v-if="showEndDate" cols="5">
          <SelectDate
            v-model="endDate"
            :label="$t('contract.label.endDate')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="monthlyCapacity"
            :label="$t('contract.label.monthlyCapacity')"
            :rules="[rules.maxCapacity]"
            hide-details="auto"
            type="number"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="dailyCapacity"
            :label="$t('contract.label.monthlyAmount')"
            :rules="[rules.maxCapacity]"
            hide-details="auto"
            type="number"
            outlined
          />
        </v-col>
      </v-row>
      <v-row class="mb-4">
        <v-col>
          <v-text-field
            v-model="overuseFee"
            :label="$t('contract.label.overuseFee')"
            :rules="[rules.optionalNotNegative]"
            :disabled="getServicesFromOldContract"
            hide-details="auto"
            type="number"
            outlined
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="applyDefaultContract"
        :disabled="disableStatus"
        color="primary"
        elevation="0"
        large
      >
        Confirmar
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, maxCapacity, optionalNotNegative } from '@/util/errorHandling'
import { toOveruseFee } from '@/util/overuseFee'

import Modal from '@/components/app/Modal'
import RealEstateServiceTypeSelect from '@/components/realEstate/RealEstateServiceTypeSelect'
import HCheckbox from '@/components/app/HCheckbox'
import SelectDate from '../../date/SelectDate'

export default {
  name: 'ModalAddDefaultContract',

  props: {
    customers: {
      type: Array,
    },
  },

  components: {
    Modal,
    HCheckbox,
    RealEstateServiceTypeSelect,
    SelectDate
},

  data() {
    return {
      subscriptionTypes: [
        { name: 'Avulso', value: 'SINGLE_PURCHASE' },
        { name: 'Pré-pago', value: 'PREPAID' },
        { name: 'Pré-pago-SAAS', value: 'PREPAID_SAAS' },
        { name: 'Pós-pago', value: 'POSTPAID' },  
        { name: 'Pós-pago-SAAS', value: 'POSTPAID_SAAS' },  
        { name: '3 meses', value: 'SUBSCRIPTION_TRIMESTER' },
        { name: '6 meses', value: 'SUBSCRIPTION_SEMESTER' },
        { name: '9 meses', value: 'SUBSCRIPTION_NONAMESTER' },
        { name: '12 meses', value: 'SUBSCRIPTION_YEAR' },
        { name: 'Vitalício', value: 'SUBSCRIPTION_LIFELONG' },
      ],
      subscriptionType: null,
      services: [],
      getServicesFromOldContract: false,
      startDate: null,
      endDate: null,
      monthlyCapacity: null,
      dailyCapacity: null,
      overuseFee: null,
      rules: {
        required,
        maxCapacity,
        optionalNotNegative,
      },
    }
  },

  computed: {
    ...mapGetters(['isLoading']),

    showEndDate() {
      return ['POSTPAID', 'POSTPAID_SAAS'].includes(this.subscriptionType)
    },

    disableStatus() {
      return !this.subscriptionType || this.isLoading || (this.services.length <= 0 && !this.getServicesFromOldContract)
        || !this.startDate || !this.monthlyCapacity || this.monthlyCapacity < 0 || !this.dailyCapacity || this.dailyCapacity < 0
        || (toOveruseFee(this.overuseFee) ?? 0) < 0
    },
  },

  watch: {
    getServicesFromOldContract(newValue, oldValue) {
      if (newValue) {
        this.services.length = 0
      }
    },

    subscriptionType() {
      if (!this.showEndDate) {
        this.endDate = null
      }
    },
  },

  methods: {
    ...mapActions(['addDefaultContract']),

    applyDefaultContract() {
      this.addDefaultContract(
        this.customers.map(({ id }) => ({
          realEstateId: id,
          subscriptionType: this.subscriptionType,
          services: this.services,
          getServicesFromOldContract: this.getServicesFromOldContract,
          start_date: this.startDate,
          end_date: this.endDate || null,
          monthly_capacity: this.monthlyCapacity,
          daily_capacity: this.dailyCapacity,
          overuse_fee: toOveruseFee(this.overuseFee),
        }))
      )
    },
  },
}
</script>
